module.exports = __webpack_public_path__ + "img/otp.a6ce0e6.svg";